var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gradPhoto" }, [
    _c(
      "div",
      { staticClass: "cont-box" },
      [
        _c("Title", { attrs: { text: "毕业照" } }),
        _vm.info.is_graduate_img == 1
          ? _c("div", [
              _vm.info.is_check != 0
                ? _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("审核状态"),
                      ]),
                      _c(
                        "span",
                        { staticClass: "value" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm._f("isCheckStyle")(_vm.info.is_check),
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("isCheckFilter")(_vm.info.is_check)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    (_vm.info.check_remark ? true : false)
                      ? _c("div", { staticClass: "item" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("审核备注"),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.info.check_remark)),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "title" }, [_vm._v("毕业照")]),
                      _c(
                        "span",
                        { staticClass: "value" },
                        [
                          (_vm.info.grad_img ? true : false)
                            ? _c("el-image", {
                                staticStyle: {
                                  height: "200px",
                                  width: "200px",
                                },
                                attrs: {
                                  src: _vm.info.grad_img,
                                  fit: "contain",
                                  "preview-src-list": [_vm.info.grad_img],
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.info.is_check == 0 || _vm.info.is_check == 3
                ? _c(
                    "div",
                    { staticClass: "btn-box" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "",
                            "http-request": _vm.upLoadImg,
                            "show-file-list": false,
                          },
                        },
                        [
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v("上传毕业照"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v("蓝底标准证件照，跟学信网上的学历照片一致"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }